import * as React from "react";

import { UitkText } from "uitk-react-text";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";

import { getDirectDistance } from "components/flexComponents/Hotels/views/HotelsViews/HotelUtils";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

const DirectDistance = (props: { hotel: Hotel; className: string; context: ExtendedContextStore }) => {
  const { hotel, className, context } = props;
  const directDistance = getDirectDistance(hotel, context);

  if (!directDistance) {
    return null;
  }

  return (
    <UitkText size={300} className={className}>
      <UitkIcon className="distance-icon" size={UitkIconSize.SMALL} name="place" />
      <span className="all-l-margin-one">{directDistance}</span>
    </UitkText>
  );
};

export default DirectDistance;
